<template>
  <button @click="open" class="btn btn-sm btn-primary mr-1">
    <font-awesome-icon icon="mobile"/>&nbsp;{{ $t('buyMoreMonthlyUserPackage') }}
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('buyMoreMonthlyUserPackage')">
      <client-select :model="formModel" attribute="client" :errors="formErrors" :label="$t('chooseClient')"></client-select>
      <template v-if="formModel.client">
        <div class="alert alert-warning" v-if="!clientLoading && !isPackage">{{$t('notMonthlyUserPackage')}}</div>
        <div class="alert alert-warning" v-if="packageExpireTime > 0 && packageExpireTime <= Date.now()">{{$t('expiredPackage')}}</div>
        <p>
          <span>{{$t('packageExtLimit')}}</span>:
          <b-spinner small v-if="clientLoading"></b-spinner>
          <b v-else-if="packageLimit">{{packageLimit}}</b>
          <b v-else>{{$t('noInfo')}}</b>
        </p>
        <p>
          <span>{{$t('packageExpireTime')}}</span>:
          <b-spinner small v-if="clientLoading"></b-spinner>
          <b v-else-if="packageExpireTime">{{packageExpireTime | moment('DD/MM/YYYY HH:mm:ss')}}</b>
          <b v-else>{{$t('noInfo')}}</b>
        </p>
        <p>
          <span>{{$t('creditBalance')}}: </span>
          <b-spinner small v-if="clientLoading"></b-spinner>
          <b v-else>{{creditBalance | numFormat}}</b>
        </p>
        <p>
          <span>{{$t('creditLimit')}}: </span>
          <b-spinner small v-if="clientLoading"></b-spinner>
          <b v-else>{{creditLimit | numFormat}}</b>
        </p>
      </template>
      <form-input :model="formModel" attribute="limitAdded" :errors="formErrors" :label="$t('numberOfPackageToBuy')"></form-input>
      <form-input :model="formModel" attribute="note" :errors="formErrors" :label="$t('note')"></form-input>
      <hr>
      <p class="text-right"><b>{{ $t('numberOfPackageToBuy') }}</b>: <span class="text-success">{{ formModel.limitAdded }}</span></p>
      <p class="text-right" v-if="numberOfMonth > 0"><b>{{ $t('numberOfMonth') }}</b>: <span class="text-success">{{ numberOfMonth }}</span></p>
      <p class="text-right"><b>{{ $t('packagePricePerMonth') }}</b>: <span class="text-success">{{ $store.state.user.planFee | numFormat }}</span></p>
      <p class="text-right" v-if="numberOfMonth > 0"><b>{{ $t('total') }}</b>: <span class="text-danger">{{ formModel.limitAdded * numberOfMonth * $store.state.user.planFee | numFormat }}</span></p>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button class="btn btn-primary float-right" @click="buyMoreExt"
                :disabled="!formModel.client || !isPackage || !packageExpireTime || (packageExpireTime > 0 && packageExpireTime <= Date.now()) || numberOfMonth <=0 || !['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)">
          {{ $t('buyMoreMonthlyUserPackage') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>

import moment from 'moment';
import ClientSelect from "../../../components/ClientSelect";

export default {
  props: ['client'],
  components: {ClientSelect},
  data() {
    return {
      showForm: false,
      service: '/client-package',
      formModel: {
        client: this.client ? this.client : null,
        limitAdded: 0
      },
      formErrors: [],
      creditBalance: 0,
      creditLimit: 0,
      isPackage: false,
      packageLimit: 0,
      packageExpireTime: 0,
      oldClient: null,
      clientLoading: false,
      total: 0
    }
  },
  methods: {
    open() {
      this.formModel = {
        client: this.client ? this.client : null,
        limitAdded: 0
      }
      if (this.formModel.client) {
        this.getClient();
      }
      this.total = 0;
      this.showForm = true
    },
    getClient(){
      this.clientLoading = true
      this.$bgService.get('/client/'+ this.formModel.client).then(response => {
        this.creditBalance = response.data.creditBalance;
        this.creditLimit = response.data.creditLimit;
        this.isPackage = response.data.isPackage;
        this.packageLimit = response.data.packageLimit;
        this.packageExpireTime = response.data.packageExpireTime;
        this.oldClient = this.formModel.client;
      }).finally(() => {
        this.clientLoading = false
      })
    },
    buyMoreExt() {
      let loader = this.$loading.show();
      this.$service({
        url: this.service + '/monthly-user/more',
        method: 'post',
        data: this.formModel
      }).then(response => {
        this.showForm = false;
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('buyMoreExtSuccess'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('buyMoreExtFail'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        this.$bus.$emit('clientPackage');
        this.$bus.$emit('loadClient');
        loader.hide();
      });
    },
  },
  computed: {
    numberOfMonth() {
      let start = moment(Date.now()).startOf('month');
      let end = moment(this.packageExpireTime).endOf('month') + 1;
      let monthCount = moment(end).diff(moment(start), 'month', true);
      if (moment().date() >= 15) {
        monthCount -= 0.5;
      }
      return monthCount
    }
  },
  watch: {
    "formModel.client": {
      handler(val) {
        if (val) {
          if (val !== this.oldClient) {
            this.getClient();
          }
        } else {
          this.oldClient = null;
          this.creditBalance = 0;
          this.creditLimit = 0;
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        buyMoreMonthlyUserPackage: 'Buy more TGU',
        packageExtLimit: 'Package ext limit',
        packageExpireTime: 'Package ext expire time',
        numberOfPackageToBuy: 'Number of package to buy',
        numberOfMonth: 'Number of month',
        packagePricePerMonth: 'Package price per month',
        notMonthlyUserPackage: 'Client is currently not using monthly user package',
        expiredPackage: 'Cannot buy more ext because client package is already expired',
        chooseClient: 'Choose client',
        buyMoreExtSuccess: 'Buy more exts successfully!',
        buyMoreExtFail: 'Fail to buy more exts',
        noInfo: 'No info'
      },
      vi: {
        buyMoreMonthlyUserPackage: 'Mua thêm TGU',
        packageExtLimit: 'Số lượng gói hiện tại',
        packageExpireTime: 'Hết hạn lúc',
        numberOfPackageToBuy: 'Số lượng gói mua thêm',
        numberOfMonth: 'Số tháng',
        packagePricePerMonth: 'Giá gói / tháng',
        notMonthlyUserPackage: 'Không thể mua thêm vì khách hàng hiện chưa sử dụng gói thoại trọn gói',
        expiredPackage: 'Không thể mua thêm vì gói đã hết hạn',
        chooseClient: 'Chọn khách hàng',
        buyMoreExtSuccess: 'Mua thêm gói thành công!',
        buyMoreExtFail: 'Mua thêm gói thất bại',
        noInfo: 'Không có dữ liệu'
      }
    }
  }
}
</script>